<sc-padding class="no-field-space">

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.show-register-transport"></sc-dictionary-label></sc-sub-title>

  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.hide-in-register-transport"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.show-pager-in-register-transport"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.show-smartphones-in-register-transport"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.show-no-handout"></ac-boolean-property>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.general-supplementaryequipment-check"></sc-dictionary-label></sc-sub-title>

  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.check-on-route-start"></ac-boolean-property>
  <sc-hint-legacy dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.check-on-route-start-hint"></sc-hint-legacy>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.supplementaryequipment-check-entrance-leave"></sc-dictionary-label></sc-sub-title>

  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.transport-entrance-check"></ac-boolean-property>
  <ac-boolean-property propertyKey="tmc-yard.supplementaryequipment.transport-leave-check"></ac-boolean-property>

</sc-padding>
